var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Get all job list elements on the current page.
 */
var jobListings = document.querySelectorAll('[data-job-listing-element]');
// Variables for Debouncing
var debounceDelay = 250;
var debounceTimer;
/**
 * Initialize click and change event listener for filter.
 * @param jobListing
 */
function initEventListeners(jobListing) {
    var filterSubmit = jobListing.querySelector('[data-job-filter-submit]');
    filterSubmit.addEventListener('click', function (event) { return filterRequest(event); });
    var filterSelects = jobListing.querySelectorAll('[data-job-filter-select]');
    filterSelects.forEach(function (filterSelect) {
        filterSelect.addEventListener('change', function (event) {
            // Set debounce delay to delay too fast requests on change event
            clearTimeout(debounceTimer);
            debounceTimer = window.setTimeout(function () {
                return selectChangedRequest(event);
            }, debounceDelay);
        });
    });
}
/**
 *  Add event listeners to all job listing elements found with filter option enabled.
 */
jobListings.forEach(function (jobListing) {
    var filterElement = jobListing.querySelector('[data-job-filter]');
    var jobList = jobListing.querySelector('[data-job-result-list]');
    if (filterElement && jobList) {
        var filterForm = filterElement.querySelector('[data-job-filter-form]');
        if (filterForm) {
            var filterSelects = jobListing.querySelectorAll('[data-job-filter-select]');
            var filterSubmit = jobListing.querySelector('[data-job-filter-submit]');
            if (filterSubmit && filterSelects) {
                initEventListeners(jobListing);
            }
        }
    }
});
/**
 * POST fetch action for filter request.
 * @param event
 */
function filterRequest(event) {
    return __awaiter(this, void 0, void 0, function () {
        var filterSubmit, form, formData, url, jobListing, response, _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.preventDefault();
                    filterSubmit = event.target;
                    form = filterSubmit.form;
                    formData = new FormData(form);
                    url = form.getAttribute('action');
                    jobListing = form.closest('[data-job-listing-element]');
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: {
                                'content-type': 'application/json',
                            },
                            body: JSON.stringify({
                                contentElementUid: formData.get('tx_wwcareer_joblisting[contentElementUid]'),
                                selectedCategory: formData.get('tx_wwcareer_joblisting[category]'),
                                selectedLocation: formData.get('tx_wwcareer_joblisting[location]'),
                            })
                        })];
                case 2:
                    response = _b.sent();
                    _a = jobListing;
                    return [4 /*yield*/, response.text()];
                case 3:
                    _a.innerHTML = _b.sent();
                    initEventListeners(jobListing);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    throw new Error('An error occurred during the job filtering fetch request: ' + error_1.message);
                case 5: return [2 /*return*/];
            }
        });
    });
}
/**
 * POST fetch action to calculate possible filter options after changing filter selections.
 * @param event
 */
function selectChangedRequest(event) {
    return __awaiter(this, void 0, void 0, function () {
        var selectElement, form, formData, url, jobListing, selectToUpdateName, selectToUpdateElement, response, _a, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    selectElement = event.target;
                    form = selectElement.form;
                    formData = new FormData(form);
                    url = form.getAttribute('data-job-filter-select-fetch-action');
                    jobListing = form.closest('[data-job-listing-element]');
                    selectToUpdateName = '';
                    if (selectElement.name == 'tx_wwcareer_joblisting[category]') {
                        selectToUpdateName = 'tx_wwcareer_joblisting[location]';
                    }
                    else if (selectElement.name == 'tx_wwcareer_joblisting[location]') {
                        selectToUpdateName = 'tx_wwcareer_joblisting[category]';
                    }
                    else {
                        return [2 /*return*/];
                    }
                    selectToUpdateElement = (selectElement.form.querySelector('select[name="' + selectToUpdateName + '"]'));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            headers: {
                                'content-type': 'application/json',
                            },
                            body: JSON.stringify({
                                contentElementUid: formData.get('tx_wwcareer_joblisting[contentElementUid]'),
                                selectedCategory: formData.get('tx_wwcareer_joblisting[category]'),
                                selectedLocation: formData.get('tx_wwcareer_joblisting[location]'),
                                selectToUpdate: selectToUpdateName,
                                optionValue: selectElement.value,
                            })
                        })];
                case 2:
                    response = _b.sent();
                    _a = selectToUpdateElement;
                    return [4 /*yield*/, response.text()];
                case 3:
                    _a.innerHTML = _b.sent();
                    initEventListeners(jobListing);
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _b.sent();
                    throw new Error('An error occurred when updating the job filter select options: ' + error_2.message);
                case 5: return [2 /*return*/];
            }
        });
    });
}
